import { useState, useEffect, useRef } from "react";
import Layout from "../components/Layout/Layout";
import classes from "../components/Profile/Profile.module.scss";
import ProfileDetails from "../components/Profile/ProfileDetails";
import Password from "../components/Profile/Password";
import Referrals from "../components/Profile/Referrals";

const Profile = () => {
const [activeTab, setActiveTab] = useState(1);
const [isDropdownOpen, setIsDropdownOpen] = useState(false);
const dropdownRef = useRef(null);

const tabs = [
  { id: 1, name: 'My Details', icon: 'fas fa-user', component: ProfileDetails },
  { id: 2, name: 'Password', icon: 'fas fa-lock', component: Password },
  { id: 3, name: 'Referrals', icon: 'fas fa-users', component: Referrals }
];

const activeTabData = tabs.find(tab => tab.id === activeTab);

// Handle click outside to close dropdown
useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      setIsDropdownOpen(false);
    }
  };

  if (isDropdownOpen) {
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);
  }

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
    document.removeEventListener('keydown', handleKeyDown);
  };
}, [isDropdownOpen]);

  return (
    <Layout>
        <section className={`${classes.profile} ${classes.modern}`}>
            <div className={classes.inner}>
                <h1 className={classes.h1}>Settings</h1>
                <div className={classes.tabArea}>
                    {/* Desktop Sidebar Tabs */}
                    <div className={classes.sidebarTabs}>
                        <button 
                            onClick={()=>setActiveTab(1)}
                            className={`${activeTab === 1 ? classes.active : classes.notActive } ${classes.button}`}>
                            <i className="fas fa-user" style={{ marginRight: '8px' }}></i>
                            My Details
                        </button>
                        <button 
                            onClick={()=>setActiveTab(2)}
                            className={`${activeTab === 2 ? classes.active : classes.notActive } ${classes.button}`}>
                            <i className="fas fa-lock" style={{ marginRight: '8px' }}></i>
                            Password
                        </button>
                        <button 
                            onClick={()=>setActiveTab(3)}
                            className={`${activeTab === 3 ? classes.active : classes.notActive } ${classes.button}`}>
                            <i className="fas fa-users" style={{ marginRight: '8px' }}></i>
                            Referrals
                        </button>
                    </div>

                    {/* Mobile Dropdown */}
                    <div className={classes.dropdownContainer} ref={dropdownRef}>
                        <button 
                            className={classes.dropdownTrigger}
                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                            aria-expanded={isDropdownOpen}
                            aria-haspopup="true"
                        >
                            <span className={classes.dropdownLabel}>
                                <i className={activeTabData.icon}></i>
                                {activeTabData.name}
                            </span>
                            <i className={`fas fa-chevron-${isDropdownOpen ? 'up' : 'down'} ${classes.dropdownArrow}`}></i>
                        </button>
                        
                        {isDropdownOpen && (
                            <>
                                {/* Mobile backdrop */}
                                <div 
                                    className={classes.dropdownBackdrop}
                                    onClick={() => setIsDropdownOpen(false)}
                                />
                                
                                <div className={classes.dropdownMenu} role="menu">
                                    {tabs.map(tab => (
                                        <button
                                            key={tab.id}
                                            onClick={() => {
                                                setActiveTab(tab.id);
                                                setIsDropdownOpen(false);
                                            }}
                                            className={`${classes.dropdownItem} ${activeTab === tab.id ? classes.active : ''}`}
                                            role="menuitem"
                                        >
                                            <i className={tab.icon}></i>
                                            <span>{tab.name}</span>
                                            {activeTab === tab.id && <i className="fas fa-check" style={{ marginLeft: 'auto' }}></i>}
                                        </button>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                    
                    <div className={classes.tabContent}>
                        {activeTab === 1 && <ProfileDetails/>}
                        {activeTab === 2 && <Password setActiveTab={setActiveTab}/>}
                        {activeTab === 3 && <Referrals/>}
                    </div>
                </div>
            </div>
        </section>
    </Layout>
  )
}

export default Profile